
    import React from 'react';
    import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "like_24_light_jRYLx",
  "use": "like_24_light_jRYLx-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"like_24_light_jRYLx\">\n<defs>\n<linearGradient id=\"like_24_light_jRYLx_like_gradient_light_24\" x1=\"0\" y1=\"0\" x2=\"16\" y2=\"16\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#66ADFF\" />\n<stop offset=\"1\" stop-color=\"#0077FF\" />\n</linearGradient>\n</defs>\n<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"url(#like_24_light_jRYLx_like_gradient_light_24)\" />\n<path d=\"M14.4506 7.71429C16.1742 7.71429 17.5714 9.0956 17.5714 10.7995C17.5714 12.5203 16.8741 13.383 13.916 15.6575L12.5701 16.6924C12.2348 16.9502 11.7652 16.9502 11.4299 16.6924L10.084 15.6575C7.12598 13.383 6.42859 12.5203 6.42859 10.7995C6.42859 9.0956 7.82584 7.71429 9.54943 7.71429C10.4729 7.71429 11.2934 8.14405 12 8.97554C12.7066 8.14405 13.5272 7.71429 14.4506 7.71429Z\" fill=\"white\" /> \n</symbol>"
});
    sprite.add(symbol);

    const Like_24LightJRyLxSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "like_24_light_jRYLx", width: 24, height: 24, ...props })
    }

    export { Like_24LightJRyLxSpriteSymbolComponent as ReactComponent };
  